import common from "../common";

export default class DisplayObjectManager {
constructor()
    {
		this.colours = {black:0x000000, white:0xFFFFFF, lightBlue:0x48baef};
    	this.colourTextures = {};
    	this.res = common.resolution;
    }

init()
    {
    	this.createColourTextures();
    }
/*
PROPERTIES (GENERIC):
	parent: DisplayObject
	x: Number
	y: Number
	rotation: Number (radians)
	degrees: Number (degrees)
	scaleX: Number
	scaleY: number
	scale: Number
	anchorX: Number
	anchorY: Number
	anchor: Number
	width: Number
	height: Number
	alpha : Number
	tint: Number
	visible: Boolean
	res: Boolean,
	mask: DisplayObject,
	interactive: Boolean,
	buttonMode: Boolean,
	blendMode: String

PROPERTIES (Sprite only)
	asset: String
	texture: Texture,
	colourTexture: String

PROPERTIES (Circle/Rectangle only)
	fillColour: Hex
	fillAlpha: Number
	lineWidth: Number
	lineColour: Hex
	lineAlpha: Number
	asTexture: Boolean

PROPERTIES (Rectangle only)
	rect: Object
	rectWidth: Number
	rectHeight: Number

PROPERTIES (Circle only)
	circ: Object
	radius: Number
*/

container(props)
	{
		var obj = new PIXI.Container();
		this.set(obj, props);

		return obj;
	}

sprite(props)
	{
		var t = props.texture;
		if(t == null && props.asset)
			t = P3.assets.texture(props.asset)
		else if(t == null)
		 	t = PIXI.Texture.EMPTY;
		
		if(props.colourTexture)
		{
			t = this.colourTextures[props.colourTexture];
		}

		var obj = new PIXI.Sprite(t);
		this.set(obj, props);

		return obj;
	}

rectangle(props)
	{
		props = props || {};

		if(props.res)
		{
			var resAlter = ['x', 'y', 'rectWidth', 'rectHeight', 'width', 'height'];
			if(props.rect)
			{
				for(var i in resAlter)
				{
					if(props.rect[resAlter[i]])
					{
						props.rect[resAlter[i]] = props.rect[resAlter[i]] * this.res;
					}
				}
			}
			for(var i in resAlter)
			{
				if(props[resAlter[i]])
				{
					props[resAlter[i]] = props[resAlter[i]] * this.res;
				}
			}
		}

		var obj = new PIXI.Graphics();
		this.set(obj, props);

		var x = props.rect && props.rect.x != undefined ? props.rect.x : 0;
		var y = props.rect && props.rect.y != undefined ? props.rect.y : 0;
		var width = props.rect && props.rect.width != undefined ? props.rect.width : props.rectWidth;
		var height = props.rect && props.rect.height != undefined ? props.rect.height : props.rectHeight;
		if (width == undefined) width = 0;
		if (height == undefined) height = 0; 

		props.fillColour != undefined && obj.beginFill(props.fillColour, props.fillAlpha);

		if(props.lineWidth != undefined || props.lineColour != undefined)
		{
			obj.lineStyle(props.lineWidth != undefined ? props.lineWidth : 1, props.lineColour != undefined ? props.lineColour : 0x000000, props.lineAlpha);
		}

		obj.drawRect(x, y, width, height);

		if(props.asTexture)
		{
			var texture = common.renderer.generateTexture(obj);
			obj.destroy();
			return texture;
		}
		else
		{
			return obj;
		}
	}

circle(props)
	{
		props = props || {};

		if(props.res)
		{
			var resAlter = ['x', 'y', 'radius'];
			if(props.rect)
			{
				for(var i in resAlter)
				{
					if(props.rect[resAlter[i]])
					{
						props.rect[resAlter[i]] = props.rect[resAlter[i]] * this.res;
					}
				}
			}
			for(var i in resAlter)
			{
				if(props[resAlter[i]])
				{
					props[resAlter[i]] = props[resAlter[i]] * this.res;
				}
			}
		}

		var obj = new PIXI.Graphics();
		this.set(obj, props);

		var x = props.circ && props.circ.x != undefined ? props.circ.x : 0;
		var y = props.circ && props.circ.y != undefined ? props.circ.y : 0;
		var radius = props.circ && props.circ.radius != undefined ? props.circ.radius : props.radius;
		if(radius == undefined) radius = 10;

		if(props.fillColour != undefined)
		{
			obj.beginFill(props.fillColour, props.fillAlpha != undefined ? props.fillAlpha : 1);
		}

		if(props.lineWidth != undefined || props.lineColour != undefined)
		{
			obj.lineStyle(props.lineWidth != undefined ? props.lineWidth : 1, props.lineColour != undefined ? props.lineColour : 0x000000, props.lineAlpha);
		}

		obj.drawCircle(x, y, radius);
		
		if(props.asTexture)
		{
			var texture = common.renderer.generateTexture(obj);
			obj.destroy();
			return texture;
		}
		else
		{
			return obj;
		}
	}

set(obj, props)
	{
		props = props || {};

		if(props.res)
		{
			var resAlter = ['x', 'y', 'width', 'height']//, 'scale', 'scaleX', 'scaleY'];
			for(var i in resAlter)
			{
				if(props[resAlter[i]])
				{
					props[resAlter[i]] = props[resAlter[i]] * this.res;
				}
			}
		}

		var standards = ['x', 'y', 'rotation', 'alpha', 'tint', 'visible', 'mask', 'interactive', 'buttonMode', 'blendMode'];
		for(var i in standards)
		{
			if(props[standards[i]] != undefined) obj[standards[i]] = props[standards[i]];
		}

		if(props.scale != undefined) obj.scale = new PIXI.Point(props.scale, props.scale);
		if(props.anchor != undefined) obj.anchor = new PIXI.Point(props.anchor, props.anchor);

		obj.rotation = props.degrees != undefined ? props.degrees * PIXI.DEG_TO_RAD : obj.rotation;
		obj.scale.x = props.scaleX != undefined ? props.scaleX : obj.scale.x;
		obj.scale.y = props.scaleY != undefined ? props.scaleY : obj.scale.y;
		if(obj.anchor)
		{
			obj.anchor.x = props.anchorX != undefined ? props.anchorX : obj.anchor.x;
			obj.anchor.y = props.anchorY != undefined ? props.anchorY : obj.anchor.y;
		}

		if(props.width != undefined) obj.width = props.width;
		if(props.height != undefined) obj.height = props.height;

		if(props.parent != undefined) props.parent.addChild(obj);
	}

createColourTextures()
	{
		for(var i in this.colours)
		{
			this.colourTextures[i] = this.rectangle({rectWidth:this.adjustForResolution(50), rectHeight:this.adjustForResolution(50), fillColour:this.colours[i], asTexture:true});
		}
	}

adjustForResolution(value)
	{
		return value * this.res;
	}

}
